import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Crown } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const PlanStatusCard = () => {
  const [usage, setUsage] = useState(null);

  useEffect(() => {
    axios.get(`${API}/usage`, { withCredentials: true }).then(({ data }) => setUsage(data)).catch(() => setUsage(null));
  }, []);

  if (!usage) return null;
  const isWriter = usage.plan === 'writer';
  const expired = usage.plan === 'expired';
  const expires = usage.plan_expires_at ? new Date(usage.plan_expires_at).toLocaleDateString(undefined, { dateStyle: 'medium' }) : null;
  const trialEnds = usage.trial_ends_at ? new Date(usage.trial_ends_at).toLocaleDateString(undefined, { dateStyle: 'medium' }) : null;
  const title = isWriter ? 'Writer plan' : expired ? 'Trial ended' : 'Free trial';
  const description = isWriter
    ? (expires ? `Active until ${expires}` : 'Active')
    : expired
      ? 'AI prompts are paused — your writing tools still work'
      : `${usage.prompts.limit} prompts a day until ${trialEnds}`;

  return (
    <Card className={`border-amber-100 shadow-sm ${isWriter ? 'bg-gradient-to-br from-amber-100/60 to-orange-100/60' : expired ? 'bg-rose-50/60' : ''}`} data-testid="plan-status-card">
      <CardHeader>
        <CardTitle className="font-display text-xl flex items-center text-amber-950">
          <Crown className={`h-5 w-5 mr-2 ${isWriter ? 'text-orange-600' : 'text-amber-400'}`} />
          {title}
        </CardTitle>
        <CardDescription data-testid="plan-status-text">{description}</CardDescription>
      </CardHeader>
      <CardContent className="text-sm text-amber-900/80 space-y-3">
        {!expired && <p>Today: {usage.prompts.used}/{usage.prompts.limit} prompts{usage.illustrations.limit > 0 ? ` · ${usage.illustrations.used}/${usage.illustrations.limit} illustrations` : ''}</p>}
        <Link to="/pricing">
          <Button variant={isWriter ? 'outline' : 'default'} className={`w-full ${isWriter ? 'border-amber-900 text-amber-900 hover:bg-amber-100' : 'bg-amber-900 hover:bg-amber-800 text-amber-50'}`} data-testid="plan-status-cta">
            {isWriter ? 'Add more time' : 'Upgrade to Writer'}
          </Button>
        </Link>
      </CardContent>
    </Card>
  );
};
